import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Quote } from 'lucide-react';
import { HeroSlideshow } from '../components/HeroSlideshow';
import { ParallaxSection } from '../components/ParallaxSection';
import { ProjectShowcase } from '../components/ProjectShowcase';
import { DevelopmentAreas } from '../components/DevelopmentAreas';
import { BrandFamily } from '../components/BrandFamily';
import { SevenIslands } from '../components/SevenIslands';
import { BoathouseFeature } from '../components/BoathouseFeature';
export function HomePage() {
  return <div className="bg-white" data-id="element-427" data-mp="36qtzjuswcv0o">
      <HeroSlideshow data-id="element-428" data-mp="36r3pxjhut46w" />

      {/* Positioning statement */}
      <section className="py-24 px-6 md:px-10 bg-white" data-id="element-429" data-mp="31zvfql8p9eso">
        <div className="max-w-5xl mx-auto" data-id="element-430" data-mp="31yaob4hombz1">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-431" data-mp="2e9hmwsiajbx1">
            <h2 className="text-4xl md:text-6xl font-serif font-bold text-black leading-tight mb-8" data-id="element-432" data-mp="2aomqn3nlc0k0">
              From opportunity to completion.
            </h2>
            <div className="w-16 h-[2px] bg-[#C5A55A] mb-8" data-id="element-433" data-mp="2jgx36rlyki4f" />
            <p className="text-xl md:text-2xl text-gray-700 font-light leading-relaxed max-w-3xl" data-id="element-434" data-mp="2jjjbwukl53o8">
              Sinclair Development identifies opportunities and brings together
              the planning, design, construction and management necessary to
              turn them into successful properties throughout Southwest Florida.
            </p>
          </motion.div>
        </div>
      </section>

      <SevenIslands data-id="element-435" data-mp="25psc4dwnoy5p" />

      <BoathouseFeature data-id="element-436" data-mp="25qbkb2wi886j" />

      <ProjectShowcase data-id="element-437" data-mp="25ql7yju2u392" />

      <DevelopmentAreas data-id="element-438" data-mp="25np98taenajk" />

      <BrandFamily data-id="element-439" data-mp="3c64bujf4mo3e" />

      {/* Testimonial */}
      <section className="py-24 px-6 md:px-10 bg-black text-white" data-id="element-440" data-mp="3c5cfh6dpgmc2">
        <div className="max-w-4xl mx-auto text-center" data-id="element-441" data-mp="3h45uj38n4lec">
          <Quote className="w-12 h-12 text-[#C5A55A] mx-auto mb-8" aria-hidden="true" data-id="element-442" data-mp="3h71pqjt3svz3" />
          <blockquote className="text-2xl md:text-3xl font-serif italic leading-relaxed mb-8 text-gray-100" data-id="element-443" data-mp="2mhywblwzn7pm">
            "Sinclair didn't just build our headquarters; they created a
            landmark. Their attention to detail and commitment to excellence is
            unmatched in the industry."
          </blockquote>
          <div className="text-[#C5A55A] font-bold tracking-[0.2em] uppercase text-sm" data-id="element-444" data-mp="28pirqgofv1ml">
            Jon Engh
          </div>
          <div className="text-gray-500 text-sm mt-2" data-id="element-445" data-mp="23ss9pnt2pvyj">
            Senior Vice President, First Horizon Bank
          </div>
        </div>
      </section>

      {/* CTA */}
      <ParallaxSection backgroundImage="https://images.unsplash.com/photo-1590274853856-f22d5ee3d228?w=1920&q=80" height="h-[60vh]" data-id="element-446" data-mp="2dp4zwbpetroj">
        <div className="text-center" data-id="element-447" data-mp="1pxhjinprxz0i">
          <h2 className="text-4xl md:text-6xl font-serif font-bold text-white mb-6" data-id="element-448" data-mp="1l1iy98zqsx4b">
            Sinclair Develops.
          </h2>
          <p className="text-xl text-gray-200 mb-10 max-w-2xl mx-auto" data-id="element-449" data-mp="h45qixkxfuy">
            Have land, a building or an opportunity in Southwest Florida? Let's
            look at what it can become.
          </p>
          <Link to="/contact" className="inline-block bg-[#C5A55A] hover:bg-[#D4AF37] text-black px-10 py-4 text-lg font-bold rounded-sm transition-colors duration-200" data-id="element-450" data-mp="3mrq7mcuhf1qi">
            Start the conversation
          </Link>
        </div>
      </ParallaxSection>
    </div>;
}